/**
 * Bar heights (0.2 - 1) for the static stand-in waveform of a voice note that
 * has not been decoded yet. Derived from the URL, so the same note always shows
 * the same shape (no flicker between renders) and different notes differ.
 */
export function placeholderBars(seed: string, count: number): number[] {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const bars: number[] = [];
  for (let i = 0; i < count; i++) {
    // xorshift32
    h ^= h << 13;
    h ^= h >>> 17;
    h ^= h << 5;
    bars.push(0.2 + 0.8 * (((h >>> 0) % 1000) / 999));
  }
  return bars;
}
